/**
 * The DUPLICATE_CAPTURE kind code (@lodex-pro/shared DUPLICATE_CAPTURE_KIND), mirrored for
 * the browser: the shared barrel may only be imported for types here. Pinned equal by a test.
 */
export const DUPLICATE_KIND = 'DUPLICATE_CAPTURE';

/** #60 (DEC-365) — shared jobs/site-change.ts SITE_CHANGE_CONFLICT_KIND, mirrored the same way. */
export const SITE_CHANGE_KIND = 'SITE_CHANGE';
